module.exports = __webpack_public_path__ + "static/media/74 - Cocteau Twins - Cherry-coloured Funk.ef545857.mp3";